import colors from '../../../../../utils/colors';
import { StyledInput } from '../ui';
import {media} from '../../../../../utils/uiSizes';

const Base = StyledInput.withComponent('span');
const StyledStaticField = Base.extend`
  border: 0;
  color: ${colors.GRAY};
  padding-left: 0;
  padding-right: 0;
  background: none;
  display: block;
  word-break: break-word;
  ${media.tablet`
  	word-break: inherit;
  `}
`;

export default StyledStaticField;


// WEBPACK FOOTER //
// ./src/modules/common/components/form/ui/StyledStaticField.js